import store from '@/store'
import { Message } from 'element-ui'

// 全局的加载提示工具
const requestQueue = []
let loadingInstance

function checkShowLoading() {
  const now = new Date().getTime()
  const list = requestQueue.filter(request => {
    return now - request.startTime >= 2000
  })
  if (list.length > 0) {
    if (!store.state.app.loading) {
      store.commit('app/SET_LOADING', true)
      loadingInstance = Message({ message: '努力工作中...', type: 'info', duration: 0 })
    }
  } else {
    store.commit('app/SET_LOADING', false)
    if (loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }
  }
}

export function addRequest(request) {
  request.startTime = new Date().getTime()
  requestQueue.push(request)
  setTimeout(() => {
    checkShowLoading()
  }, 2000)
}

export function removeRequest(request) {
  for (let i = 0; i < requestQueue.length; i++) {
    if (request.uuid === requestQueue[i].uuid) {
      requestQueue.splice(i, 1)
      break
    }
  }
  checkShowLoading()
}
